<!-- <app-verify-identity-phone-number
  (toggleForm)="toggleOpen($event)"
></app-verify-identity-phone-number>

<app-verify-identity-modal-form *ngIf="open"></app-verify-identity-modal-form> -->

<app-verify-identity-phone-number-confirmation
  [confirmedAt]="phoneNumberConfirmedAt"
></app-verify-identity-phone-number-confirmation>

<app-verify-identity-email-confirmation
  [confirmedAt]="emailConfirmedAt"
  [email]="userEmail"
></app-verify-identity-email-confirmation>

<div class="footer-link">
  Having trouble?
  <a routerLink="/logout" class="link">Log out</a>
</div>
